import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SnoozeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Snooze",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14.71 30.57c-8.19 0-14.85-6.66-14.85-14.86 0-6.2 3.89-11.56 9.91-13.65.6-.21 1.25.11 1.45.71s-.11 1.25-.71 1.45C5.43 5.99 2.14 10.5 2.14 15.71c0 6.93 5.64 12.57 12.57 12.57 4.47 0 8.42-2.41 10.57-6.3-.71.12-1.41.17-2.18.17-4.66 0-9.03-1.88-11.69-5.02-2.05-2.42-2.9-5.42-2.39-8.46.1-.62.7-1.03 1.32-.94.62.1 1.04.69.94 1.32-.4 2.4.25 4.69 1.88 6.61 2.23 2.63 5.95 4.21 9.95 4.21 1.35 0 2.42-.19 3.81-.66.42-.14.87-.04 1.18.27s.41.77.27 1.18c-2.09 6.02-7.45 9.91-13.65 9.91ZM30.71 8.86H25c-.46 0-.88-.28-1.06-.71s-.08-.92.25-1.25l3.76-3.76H25a1.14 1.14 0 1 1 0-2.28h5.71c.46 0 .88.28 1.06.71s.08.92-.25 1.25l-3.76 3.76h2.95a1.14 1.14 0 1 1 0 2.28"
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.43 13.43h-4.57c-.46 0-.88-.28-1.06-.71s-.08-.92.25-1.25l2.62-2.62h-1.81a1.14 1.14 0 1 1 0-2.28h4.57c.46 0 .88.28 1.06.71s.08.92-.25 1.25l-2.62 2.62h1.81a1.14 1.14 0 1 1 0 2.28"
    })]
  }));
};
SnoozeIcon.displayName = 'SnoozeIcon';